module.exports = __webpack_public_path__ + "static/media/login_bg.0691ed1a.svg";